<yat-web-checkout-header title="Register for Academic Program" [pictureSource]="'icon-academic'" [subtitle]="email$ | async"></yat-web-checkout-header>
